





















import * as _ from 'lodash';
import {Vue, Component} from 'vue-property-decorator';
import {Mutation, Getter, namespace} from 'vuex-class';
import {ImageFilter} from '../filters/filters.d';
import {FILTER_METADATA} from '../filters/filter.const';
import {Filters} from '../filters/filters';

const ImageFilterMutation = namespace('imageFilter', Mutation);
const ImageFilterGetter = namespace('imageFilter', Getter);

@Component
export default class SliderEditor extends Vue {
  private FILTER_METADATA = FILTER_METADATA;

  private activeTab = '';

  private currentImageName = '';
  private currentFilters = this.getDefaultFilters();

  @ImageFilterMutation('updateFilter')
  private updateFilter: (payload: {filterType: string, filterValue: number, imageName: string}) => void;
  @ImageFilterGetter('selectedImage') private selectedImage: File;
  @ImageFilterGetter('filters') private filters: {[key: string]: Filters};

  private mounted() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === 'imageFilter/selectImage') {
        this.init(mutation.payload);
      }
    });
  }

  private init(image: File | undefined) {
    if (image && image.name) {
      this.activeTab = 'blur';
      this.currentImageName = image.name;

      if (this.filters[image.name]) {
        this.currentFilters = this.filters[image.name].getValues();
      } else {
        this.currentFilters = this.getDefaultFilters();
      }
    }
  }

  private formatTooltip(type: string) {
    return (value: number) => value;
  }

  private onFilterChanged(filterType: string) {
    this.updateFilter({
      filterType,
      filterValue: this.currentFilters[filterType],
      imageName: this.currentImageName,
    });
  }

  private getDefaultFilters(): ImageFilter {
    return new Filters().getValues();
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/image-filter/image-editor/slider-editor/slider-editor.vue